import * as React from 'react';

import Moment from 'moment';
import { Button } from '../static/Elements';
import Modal from '../static/Modal';
import OpenWebDetails from './OpenWebDetails';
import Icon from '../static/Icons';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-enterprise";
import OpenWebRun from "./OpenWebRun";

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';

import createLogger from '../../utils/createLogger';
const DEBUG = false;
const debug = createLogger(DEBUG, `OpenWebGrid.js`);

class OpenWebGrid extends React.Component {

  /*----- lifecycle methods -----*/
  constructor(props){
    super(props);

    this.state = {
      detailsModalIsOpen: false,
      scrapeModalIsOpen: false,
      selectedScrape: null,
    };

    this.gridApi = null;
    this.gridColumnApi = null;
    this.gridOptions = {
      statusBar: {
        statusPanels: [
          { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' }
        ]},
      onRowDoubleClicked: this.openDetailsModal,
    }
  }

  componentDidMount() {
      debug.enter(`componentDidMount`);
      debug.log('    state:', this.state);
      debug.log('    props:', this.props);
      const { updateState } = this;

      updateState();
  }

  componentDidUpdate(prevProps, prevState) {
    const { updateState } = this;
    debug.enter('componentDidUpdate');
    debug.log('Props before/after', prevProps, this.props);
    debug.log('State before/after', prevState, this.state);

    updateState();
  }

  updateState = () => {
    const { openwebs } = this.props;
    const { gridApi } = this;

    if(gridApi) {
      if(!openwebs || openwebs.length === 0) {
        gridApi.showLoadingOverlay();
      } else {
        gridApi.hideOverlay();
      }
    }
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    this.updateState();
  };

  /*----- event handlers -----*/

  openDetailsModal = (params) => {
    const {_id} = params.data;
    const {getOpenWeb} = this.props;
    getOpenWeb(_id)
      .then(() => {
        const {openwebs} = this.props;
        const scrape = openwebs.find(function(s){return s._id === _id});
        this.setState({selectedScrape: scrape, detailsModalIsOpen: true});
      })
      .catch((error) => {
        debug.log(error);
      })
  };

  closeDetailsModal = () => {
    this.setState({detailsModalIsOpen: false});
  };

  openScrapeModal = () => {
    this.setState({scrapeModalIsOpen: true});
  };

  closeScrapeModal = () => {
    this.setState({scrapeModalIsOpen: false});
  };

  /* ------- getters/formatters -------*/
  statusGetter = params => params.data.finished !== null ?
    "Finished" : (Moment(params.data.start).isBefore(Moment().subtract(3, 'days'))) ?
      "Timed out" : "In Progress";

  whoGetter = params => params.data.who ? params.data.who : "Unknown";

  startedFormatter = params => (params.data.start && params.data.start !== null) ?
    Moment(params.data.start).format('MMMM Do YYYY, h:mm:ss a') : "Error";

  updatedFormatter = params => (params.data._updated !== null) ?
    Moment(params.data._updated).format('MMMM Do YYYY, h:mm:ss a') : "";

  finishedFormatter = params => (params.data.finished && params.data.finished !== null) ?
    Moment(params.data.finished).format('MMMM Do YYYY, h:mm:ss a') : "";

  /*----- rendering -----*/
  render () {

    const {
      closeDetailsModal,
      openScrapeModal,
      closeScrapeModal,
    } = this;

    const {
      detailsModalIsOpen,
      scrapeModalIsOpen
    } = this.state;

    const {
      openwebs,
      postOpenWebs,
      canStart,
      getOpenWebs,
      user,
    } = this.props;

    const columnDefs = [
      {headerName: "OpenWeb Scrape", field: "name", resizable: true, sortable: true, width: 100, filter: "agTextColumnFilter", rowDoubleClicked: this.gridOptions.onRowDoubleClicked},
      {headerName: "User", valueGetter: this.whoGetter, resizable: true, sortable: true, width: 50,},
      {headerName: "Start Time", valueGetter: this.startedFormatter, resizable: true, sortable: true, width: 75, filter: 'agDateColumnFilter'},
      {headerName: "Status", valueGetter: this.statusGetter, resizable: true, sortable: true, width: 50,},
      {headerName: "Total Jobs", field: "total_jobs", resizable: true, sortable: true, width: 50,},
      {headerName: "Last Updated", valueGetter: this.updatedFormatter, resizable: true, sortable: true, width: 75,},
      {headerName: "Finished", valueGetter: this.finishedFormatter, resizable: true, sortable: true, width: 75,},
    ];

    return (
      <div className={`openweb-container`}>
        <Modal title="New OpenWeb Scrape"
               isOpen={scrapeModalIsOpen}
               close={closeScrapeModal}>
          <OpenWebRun closeModal={closeScrapeModal} postOpenWebs={postOpenWebs} canStart={canStart} getOpenWebs={getOpenWebs} user={user}/>
        </Modal>
        <Modal title="Scrape Details"
               isOpen={detailsModalIsOpen}
               close={closeDetailsModal}
               closeButton>
          <div className={`scrape-details`}>
            <OpenWebDetails scrape={this.state.selectedScrape}/>
          </div>
        </Modal>
        <div className={`openweb-header`}>
          <h2>Open Web History</h2>
          <div className={`header-button-container`}>
            <Button primary onClick={openScrapeModal}>
              <Icon.Add/> New Run
            </Button>
          </div>
        </div>
        <div className={`openweb-body simple-border ag-theme-material`}>
          <AgGridReact reactNext={true}
                       onGridReady={this.onGridReady}
                       columnDefs={columnDefs}
                       rowData={openwebs}
                       animateRows
                       gridOptions={this.gridOptions}
                       rowSelection="multiple"
                       overlayLoadingTemplate='<span class="ag-overlay-loading-center">Retrieving current Open Web data, please wait...</span>'

          />
        </div>
      </div>
    )
  }
}

export default OpenWebGrid;



// WEBPACK FOOTER //
// ./src/components/OpenWeb/OpenWebGrid.js